import { render, staticRenderFns } from "./CompetitionShow.vue?vue&type=template&id=e8204cd2&"
import script from "./CompetitionShow.vue?vue&type=script&lang=js&"
export * from "./CompetitionShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports